webpackJsonp([146288912868697],{

/***/ 379:
/***/ (function(module, exports) {

	module.exports = {"testimonials":[{"author":"Kit Menkin","email":"kitmenkin@leasingnews.org","company":"Editor/Publisher Leasing News","text":"We are very pleased to announce that Steve Geller will be joining the Leasing News Advisory Board. It was a unanimous decision."},{"author":"Bob Teichman","email":"BoTei@aol.com","company":"CLP - Teichman Financial Training","text":"Steve Geller would be an excellent addition to the Advisory Board. He is a CLP and was (and I believe continues to be) very active in EAEL... He is experienced, honorable and willing to look at both sides of a question. The newsletter (Leasing News) would benefit from his point of view."},{"author":"Bruce Kropschot","email":"BKropschot@aol.com","company":"Kropschot Financial Services","text":"Steve Geller would be an excellent addition to the Advisory Board. I have served with Steve on the EAEL Board, and he has been a tireless worker for that organization. He is highly respected by the leasing companies he has provided funding to, and he will provide valuable input to Leasing News from the important New York metropolitan area."},{"author":"Steve Crane, CLP","email":null,"company":"Bank of the West","text":"I have known Steve Geller for several years, mainly through our mutual envolvement with EAEL and UAEL. I spoke with Steve recently in Atlanta at the EAEL/NAELB gathering and he explained to me the new venture that he is involved in now that he is no longer with ORIX. I feel that he is a man of integrity and would be a great addition to the advisory board."},{"author":"Bob Rodi","email":null,"company":"LeaseNow","text":"I love Steve Geller. I have done a lot of business with him and he is a great guy. I spoke to him and have traded e-mails with him since he left. He is a very level headed guy, he's been around as long as any of us and he knows everybody, especially the bad ones that he had to watch out for at ORIX on the east coast."},{"author":"Charlie Lester","email":"clester@lpifinancial.com","company":"LPI Financial","text":"I have only met Steve Geller a couple of times, but he seems to be a very pleasant sort. I have only heard good things about him. Everything I know says he would be a valuable addition to the board."},{"author":"Rob Yohe","email":"MLOST@aol.com","company":null,"text":"Steve would be a great addition and of course as he is pursuing new opportunities this might be the thing for him. I met Steve about 7 years ago at an ELA meeting in Chicago. It was kind of funny. I had recently had neck surgery and told some people I was meeting for the first time to look for the guy in the neck brace. As it turned out Steve had just had neck surgery and was wearing a brace also. I wonder how many people came up to him asking if he was Rob Yohe. What a coincident."},{"author":"Ken Greene","email":"KGreene100@aol.com","company":null,"text":"I agree that Steve Geller would make a fine addition to the advisory board."},{"author":"Ginny Young","email":"GinnyYoung@bravacapital.com","company":"Brava Capital","text":"I think Geller would be a great addition to the advisory board."},{"author":"Bob Baker, CLP","email":null,"company":null,"text":"I have known Steve for years. He would be an excellent addition."},{"author":"Phil Dushay","email":null,"company":null,"text":"I have known Steve for quite a few years and I think he would be a great addition. He has my vote."}]}

/***/ }),

/***/ 279:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _sideNav = __webpack_require__(10);
	
	var _sideNav2 = _interopRequireDefault(_sideNav);
	
	var _testimonials = __webpack_require__(379);
	
	__webpack_require__(279);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var components = ['experience', 'memberships', 'testimonials'];
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: 'testimonials-hero' },
	      _react2.default.createElement('div', { className: 'testimonials-hero-img' })
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'testimonials-title' },
	      'Testimonials'
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'testimonials-content' },
	      _react2.default.createElement(_sideNav2.default, { components: components, base: 'experience', current: 'testimonials' }),
	      _react2.default.createElement(
	        'p',
	        { className: 'testimonials-subtitle' },
	        'Hear what others have to say about Leasing Solutions LLC and Steve Geller'
	      ),
	      _react2.default.createElement(
	        'p',
	        { className: 'testimonials-note' },
	        'When Steve was nominated to the advisory board of Leasing News, this is what they had to say:'
	      ),
	      _testimonials.testimonials.map(function (testimonial, i) {
	        return _react2.default.createElement(
	          'div',
	          { key: i, className: 'testimony' },
	          _react2.default.createElement(
	            'div',
	            { className: 'author' },
	            _react2.default.createElement(
	              'div',
	              { className: 'author-name' },
	              testimonial.author,
	              testimonial.email ? _react2.default.createElement(
	                'a',
	                { className: 'author-email-icon', href: 'mailto:' + testimonial.email },
	                _react2.default.createElement('i', { className: 'fa fa-envelope' })
	              ) : null
	            ),
	            testimonial.company ? _react2.default.createElement(
	              'div',
	              { className: 'author-company' },
	              testimonial.company
	            ) : null
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'testimony-text' },
	            testimonial.text
	          )
	        );
	      })
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-experience-testimonials-js-0aee2a066745dcfb9e33.js